import { render } from "./floatNav.vue?vue&type=template&id=67ece51d&scoped=true"
import script from "./floatNav.vue?vue&type=script&lang=js"
export * from "./floatNav.vue?vue&type=script&lang=js"

import "./floatNav.vue?vue&type=style&index=0&id=67ece51d&lang=scss&scoped=true"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ece51d"]])

export default __exports__